export const singleItemLayoutOptions = [
  { value: 'content-on-side', label: 'Aside content', icon: 'icon-page-single-hz-layout' },
  { value: 'full-width', label: 'Full width content', icon: 'icon-page-single-vt-layout' },
  { value: 'content-split', label: 'Split content', icon: 'icon-page-single-comb-layout' }
]
